import React, { useEffect } from 'react';
import { Grid, Row, Col } from '@vds/grids';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

import { Body } from '../../../common/Typography/index';
import { viewport, scrollToTop } from '../../../common/Helpers/index';
import '../tos.css';

const MobileTos = (props) => {
  useEffect(() => {
    const type = viewport();
    if (type && (type === 'mfapp' || type === 'mobile') && window) {
      scrollToTop();
    }
  }, []);

  return (
    <section className="redesignOrderReviewContainer">
      <Grid className="pad20 onlySidePad orderreview-print marginTop70" colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
        <Row>
          <Col>
            <div tabIndex={0} role="button" onClick={() => props.onClose()} onKeyDown={() => props.onClose()} className="tosBack">
              <Body primitive="span" size="large">
                Back
              </Body>
            </div>
            <div className="tosContent">{parse(props.content)}</div>
          </Col>
        </Row>
      </Grid>
    </section>
  );
};

MobileTos.propTypes = {
  content: PropTypes.string,
  onClose: PropTypes.func,
};

export default React.memo(MobileTos);
